module.exports = "<div class=c-help> <text-cheatsheet ng-if=\"$ctrl.helptype === 'markdown'\"></text-cheatsheet> <period-cheatsheet ng-if=\"$ctrl.helptype === 'period'\"></period-cheatsheet> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/help.area.html
// module id = 503
// module chunks = 0